import React, { useContext, useState } from "react";
import { Box, Center, HStack, Heading, Stack, Text, VStack } from "native-base";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { FaBusAlt } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styles from "./styles.module.css";
import banner from "../../assets/images/banner.jpeg";
import colors from "../../constants/colors";
import routes from "../../routes";
import { StateContext } from "../../contexts";
import Modal from "../../components/modal";

function HomePage() {
  const state = useContext(StateContext);

  const [isModal, setIsModal] = useState(true);

  return (
    <VStack>
      <Helmet>
        <title>Autotur</title>
      </Helmet>
      <VStack flex={1} space={10}>
        <VStack
          height="60vh"
          minHeight="450px"
          position="relative"
          overflow="hidden">
          <LazyLoadImage
            className={styles.banner}
            src={banner}
            alt="banner"
            width="100%"
            height="100%"
            effect="blur"
          />
          <div className={styles.gradient}>
            <Heading
              fontSize="xl"
              color={colors.white}
              textAlign="center"
              paddingX="25%">
              ¡Sabemos que la vida corre rápido y las ganas de viajar no
              esperan!... por eso ponemos a tu disposición un cotizador digital
              donde podrás planificar viajes de punto a punto, designar uno o
              varios domicilios de salida, puntos específicos de llegada,
              incluir paradas intermedias, elegir el vehículo más adecuado para
              tu viaje y complementarlo con experiencias en el Turibus,
              excursiones y day tours.
            </Heading>
            <Heading fontSize="2xl" color={colors.white}>
              Comencemos
            </Heading>
            <VStack
              position="absolute"
              bottom={10}
              space={3}
              alignItems="center"
              display={state.isLoggedIn && "none"}>
              <Heading fontSize="xl" color={colors.white}>
                Eres un viajero o una empresa
              </Heading>
              <HStack backgroundColor={colors.lighterGray} borderRadius={5}>
                <Link to={routes.signIn}>
                  <Stack
                    backgroundColor={colors.primary}
                    paddingX={5}
                    paddingY={2}
                    borderRadius={5}
                    minWidth={150}
                    alignItems="center">
                    <Text color={colors.white}>Viajeros</Text>
                  </Stack>
                </Link>
                <Link to={routes.signInRole.replace(":role", "agency")}>
                  <Stack
                    backgroundColor={colors.lighterGray}
                    paddingX={5}
                    paddingY={2}
                    borderRadius={5}
                    minWidth={150}
                    alignItems="center">
                    <Text color={colors.gray}>Empresas</Text>
                  </Stack>
                </Link>
              </HStack>
            </VStack>
          </div>
        </VStack>
        <Center>
          <HStack
            space={5}
            borderWidth={1}
            borderColor={colors.lighterGray}
            padding={5}>
            <FaBusAlt color={colors.primary} size={40} />
            <Heading fontSize="2xl" color={colors.primary}>
              Cotiza tu renta de autobus
            </Heading>
            <Link to={routes.experienceCreation}>
              <Box
                backgroundColor={colors.primary}
                borderRadius="full"
                paddingX={10}
                paddingY={1}>
                <Text fontSize="xl" color={colors.white}>
                  Aquí
                </Text>
              </Box>
            </Link>
          </HStack>
        </Center>
        <Modal
          isOpen={isModal}
          maxWidth={600}
          onRequestClose={() => setIsModal(false)}>
          <VStack padding={6} space={3}>
            <Text textAlign="center">
              Si tienes mas de 10 servicios al año contacta a uno de nuestro
              ejecutivos y recibe un contrato con tarifas especiales
            </Text>
            <Text textAlign="center">
              Para mayor información puede escribirnos a{" "}
              <a href="mailto:soporteautotur@mobilityado.com">
                <Text underline>soporteautotur@mobilityado.com</Text>
              </a>
            </Text>
            <button onClick={() => setIsModal(false)}>
              <Box
                backgroundColor={colors.primary}
                paddingY={3}
                borderRadius="full"
                width="full">
                <Text color={colors.white}>Cerrar</Text>
              </Box>
            </button>
          </VStack>
        </Modal>
      </VStack>
    </VStack>
  );
}

export default HomePage;
